import { html, TemplateResult } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { SlotController } from '../../../controllers/slot-controller';

import componentStyles from './se-featured-content-references-field.css.lit';

/**
 * Component for the Featured Content view mode.
 * @element se-featured-content-references-field
 *
 * @todo figure out slots and structure, document, build css file, eliminate GHS references, don't implement the slot controller in this component if we can possibly avoid it.
 *
 * @slot content - The primary slot to render the content.
 */
@customElement('se-featured-content-references-field')
export class SeFeaturedContentReferencesField extends OutlineElement {
  static styles = [componentStyles];

  // Implementing the slot controller for slot testing but NOT shadow-shift.
  slots = new SlotController(this, false);

  /**
   * Whether or not the component should be 100% height of its parent.
   * If TRUE, the Host will be `height: 100%`.
   */
  // @property({ type: Boolean, attribute: 'height-grow', reflect: true })
  // heightGrow = false;

  @state() content: boolean;

  firstUpdated(): void {
    this.content = this.slots.test('content');
  }

  render(): TemplateResult {
    const wrapperClasses = {
      'se-featured-content-references-field__wrapper': true,
    };

    return html`
      <div class="${classMap(wrapperClasses)}">
        ${this.content
          ? html`<div class="se-featured-content-references-field__content">
              <slot name="content"></slot>
            </div> `
          : null}
      </div>
    `;
  }
}
